import MyEventEmitter from '~/utils/emiter';

let startX: number;
let moveX: number;
const sensitivity = 75;
const eventOptions = { passive: true };

export function useSwipe() {
  const emitEmmiter = new MyEventEmitter();

  function touchStart(e) {
    moveX = 0;
    startX = e.touches[0].clientX;
  }

  function touchMove(e) {
    moveX = e.touches[0].clientX;
  }

  function touchEnd() {
    if (moveX && startX + sensitivity < moveX) {
      emitEmmiter.emit('swipe-left', false);
    } else if (moveX && startX - sensitivity > moveX) {
      emitEmmiter.emit('swipe-left', true);
    }
  }

  return {
    init: (gesturedZone: HTMLBaseElement) => {
      if (gesturedZone) {
        gesturedZone.addEventListener('touchstart', touchStart, eventOptions);
        gesturedZone.addEventListener('touchmove', touchMove, eventOptions);
        gesturedZone.addEventListener('touchend', touchEnd, eventOptions);
      }
    },
    emit: emitEmmiter,
    destroy: (gesuredZone: HTMLBaseElement) => {
      if (gesuredZone) {
        gesuredZone.removeEventListener('touchstart', touchStart);
        gesuredZone.removeEventListener('touchmove', touchMove);
        gesuredZone.removeEventListener('touchend', touchEnd);
      }
      try {
        emitEmmiter.removeListener('swipe-left');
      } catch (err) {
        return null;
      }
    },
  };
}
